<template>
  <div class="card-header border-0 pt-0">
    <div class="row">
      <div class="col-md-3 mb-2">
        <label class="form-control-label">Desde</label>
        <flat-picker
          :value="startDate"
          class="form-control"
          :config="{ allowInput: true, dateFormat: 'Y-m-d' }"
          @input="$emit('update:startDate', $event)"
        ></flat-picker>
      </div>

      <div class="col-md-3 mb-2">
        <label class="form-control-label">Días a cubrir</label>
        <el-select
          :value="days"
          class="w-100"
          @input="$emit('update:days', $event)"
        >
          <el-option
            v-for="option in dayOptions"
            :key="option"
            :value="option"
            :label="dayOptionLabel(option)"
          ></el-option>
        </el-select>
        <span class="text-xs text-muted">
          Hasta {{ endDate }}. De {{ MIN_DAYS }} a {{ MAX_DAYS }} días: menos no justifica
          una compra, más y el error semanal se pasa del 10%.
        </span>
      </div>

      <div class="col-md-3 mb-2">
        <label class="form-control-label">Canal de venta</label>
        <div class="pill-row">
          <button
            v-for="option in channels"
            :key="option"
            class="pill"
            :class="{ on: channel === option }"
            @click="$emit('update:channel', option)"
          >{{ channelLabel(option) }}</button>
        </div>
      </div>

      <div class="col-md-3 mb-2">
        <label class="form-control-label">Categoría de insumo</label>
        <el-select
          :value="category"
          class="w-100"
          filterable
          @input="$emit('update:category', $event)"
        >
          <el-option :value="null" label="Todas las categorías"></el-option>
          <el-option
            v-for="option in categories"
            :key="option"
            :value="option"
            :label="option"
          ></el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>
<script>
import { Select, Option } from "element-ui";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

const MIN_DAYS = 4;
const MAX_DAYS = 7;
const SUGGESTED_DAYS = 5;
const CHANNEL_LABELS = { propio: "Propio", apps: "App", todos: "Todos" };

export default {
  name: "foodcourt-supply-filters",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    flatPicker,
  },
  props: {
    startDate: { type: String, required: true },
    endDate: { type: String, required: true },
    days: { type: Number, required: true },
    channel: { type: String, required: true },
    channels: { type: Array, default: () => [] },
    category: { type: String, default: null },
    categories: { type: Array, default: () => [] },
  },
  data() {
    return { MIN_DAYS, MAX_DAYS };
  },
  computed: {
    dayOptions() {
      const options = [];
      for (let day = MIN_DAYS; day <= MAX_DAYS; day++) {
        options.push(day);
      }
      return options;
    },
  },
  methods: {
    dayOptionLabel(day) {
      const isSuggested = day === SUGGESTED_DAYS || day === SUGGESTED_DAYS + 1;
      return day + " días" + (isSuggested ? " · sugerido" : "");
    },
    channelLabel(channel) {
      return CHANNEL_LABELS[channel] || channel;
    },
  },
};
</script>
<style scoped>
.pill-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.pill {
  border: 1px solid #dfe6e1;
  background: #fff;
  border-radius: 999px;
  padding: 5px 12px;
  font-size: 12px;
  font-weight: 600;
  color: #4a5a51;
  cursor: pointer;
}
.pill.on {
  background: #5dbc85;
  border-color: #5dbc85;
  color: #fff;
}
</style>
